import { useMutationWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseMutationOptions, useQueryClient } from 'react-query';
import http from '../config/http-service';
import { masterProductsEndpoint } from './use-get-master-products-api';

type TData = void;
type TError = AxiosError;
type TVariables = number; // id

type Options = Omit<UseMutationOptions<TData, TError, TVariables>, 'mutationFn'>;
type TReturnType = ReturnType<typeof useMutationWrapper<TData, TError, TVariables>>;

// DELETE ums/v1/cms/master-products/:id
export function useDeleteMasterProductApi(options?: Options): TReturnType {
  const queryClient = useQueryClient();
  const { onSuccess: userOnSuccess, ...restOptions } = options || {};

  const mutationFn = async (id: TVariables): Promise<TData> => {
    await http.delete(`${masterProductsEndpoint}/${id}`);
  };

  return useMutationWrapper(mutationFn, {
    mutationKey: [`${masterProductsEndpoint}/delete`],
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([masterProductsEndpoint]);
      userOnSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
}
